import { Divider } from "primereact/divider";
import { AddPageHeader } from "../Common/Utils";

const HenryGrahamGreene = () => {
  return (
    <div className="reduce-width">
      {AddPageHeader("Henry Graham Greene")}
      <Divider align="center">
        <h1>Henry Graham Greene</h1>
      </Divider>
      <div className="privacy-terms-reduced-width">
        <p>
          <i>The Honorary Consul</i> is a novel written by British author Henry
          Graham Greene (October 2, 1904 – April 3, 1991). First published in
          1973, it depicts the story of Dr. Eduardo Plarr, a half-English,
          half-Paraguayan doctor who becomes entangled in a political kidnapping
          plot in a small, obscure town in northern Argentina. The novel
          explores themes of political intrigue, personal morality, and the
          complexities of human relationships, set against the backdrop of South
          American political unrest – Argentina’s "Dirty War".
        </p>
        <p>
          The reference for the first publication is: Greene, Henry Graham.
          1973. <i>The Honorary Consul</i>. London: The Bodley Head.
        </p>
        <div style={{ textAlign: "center" }}>
          <img
            src="images/Book-Greene-The-honorary-consul.png"
            alt="The Honorary Consul"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </div>
        <p>
          Since its original publication, <i>The Honorary Consul</i> has
          appeared in numerous editions. The novel has also been the subject of
          adaptations beyond the page. Most notably, it was made into a feature
          film directed by John Mackenzie in 1983, starring Bob Hoskins, Michael
          Caine, and Richard Gere – and released in the United States as{" "}
          <i>Beyond The Limit</i>. In parallel, scholars, film critics, and
          Greene enthusiasts have examined both the novel and its cinematic
          interpretation, contributing to the wider conversation around Greene's
          political and moral vision.
        </p>
        <div style={{ textAlign: "center" }}>
          <img
            src="images/Film-Mackenzie-Beyond-the-limit.png"
            alt="Beyond The Limit"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </div>
        <p>
          <i>The Honorary Consul</i> stands as one of the most prominent
          fictional treatments of the figure of an honorary consul, a diplomatic
          role that is seldom explored in literature.
        </p>
        <p style={{ fontSize: "0.8em" }}>
          Illustration sources: Jonkers Rare Books (jonkers.co.uk) and Original
          Cinematic Posters (originalcinematicposters.com).
        </p>
      </div>
    </div>
  );
};

export default HenryGrahamGreene;
